import React, { useState, useEffect } from 'react';
import {
  Input,
  InputGroup,
  InputRightElement,
  useTheme,
  Box,
} from '@chakra-ui/react';
import '../../App.css';
import { ChevronRightIcon, SearchIcon } from '@chakra-ui/icons';
import { useAppContext } from '../../App';
import { useNavigate } from 'react-router-dom';
import Fuse from 'fuse.js';
import { registerSearch } from '../../utils/dataFetch';


export default function SearcherCustom({ from, customStyles = {} }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const { isMobile, searcherText, setSearcherText, coursesInfo } = useAppContext();
  const [suggestions, setSuggestions] = useState([]);
  const style = styles(theme, isMobile, from, customStyles);

  useEffect(() => {
    if (searcherText.length >= 4 && coursesInfo?.length > 0) {
      const fuse = new Fuse(coursesInfo, {
        keys: [
          { name: 'NombreCurso', weight: 0.7 },
          { name: 'palabras_clave', weight: 0.3 }
        ],
        threshold: 0.4,
        ignoreLocation: true
      });

      const results = fuse.search(searcherText).slice(0, 4);
      setSuggestions(results.map(r => r.item.NombreCurso));
    } else {
      setSuggestions([]);
    }
  }, [searcherText, coursesInfo]);

 const handleNavigate = () => {
  if (searcherText) {
    logSearchTerm(searcherText, suggestions.length);
    navigate(`/categorias-general/Cursos`);
  }
};

const logSearchTerm = async (term, resultadosQty) => {
  try {
    await registerSearch(term, from, isMobile ? 'mobile' : 'desktop', resultadosQty);
  } catch (error) {
    console.error("Error registrando búsqueda:", error);
  }
};



  return (
    <Box position="relative" width="100%" className="sansation-bold" style={style.container}>
      {from === 'home' && (
        <p style={style.text}>
          Conocé nuestra Oferta Educativa
          <ChevronRightIcon style={style.rightArrow} fontSize={30} />
        </p>
      )}
      <InputGroup style={style.input}>
        <Input
          value={searcherText}
          placeholder="Buscar Cursos o Categorias"
          borderRadius="full"
          variant="outline"
          fontSize={isMobile ? "0.7rem" : "1rem"}
          onChange={(evt) => {
            setSearcherText(evt.target.value);
            from === 'header' && handleNavigate();
          }}
          onKeyDown={(event) => {
            if (event.key === 'Enter') handleNavigate();
          }}
        />
        <InputRightElement
          justifySelf={"end"}
          onClick={handleNavigate}
        >
          <SearchIcon
            width={"1.9rem"}
            height={"2rem"}
            color={theme.color.text.secondary}
            borderRadius={50}
            backgroundColor={searcherText ? theme.background.primary : theme.background.quaternary}
            padding={'0.25rem'}
            cursor="pointer"
          />
        </InputRightElement>
      </InputGroup>

      {suggestions.length > 0 && (
        <Box
          position="absolute"
          top="100%" // 👉 Esto lo posiciona justo debajo del input
          mt="0.5rem"
          bg="white"
          p="0.5rem"
          borderRadius="md"
          boxShadow="md"
          zIndex={10}
          width="100%"
        >
          {suggestions.map((sug, i) => (
            <Box
              key={i}
              py="0.25rem"
              px="0.5rem"
              _hover={{ background: 'gray.100', cursor: 'pointer' }}
              onClick={() => {
                setSearcherText(sug);
                setSuggestions([]);
                logSearchTerm(sug, 1); // sugerencia elegida = 1 resultado
                handleNavigate();
              }}
              fontFamily="quicksand-semibold"
            >
              {sug}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}

const styles = (theme, isMobile, from, customStyles) => ({
  container: {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: isMobile ? 'center' : 'space-around',
    alignItems: 'center',
    boxShadow: "10px 10px 20px rgba(0, 0, 0, 0.5)",
    backgroundColor: theme.background.secondary,
    ...customStyles.container
  },
  text: {
    width: isMobile ? '100%' : '90%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: isMobile ? "1rem" : "2rem",
    justifySelf: 'end',
    padding: isMobile ? '0.5rem' : 0,
    color: theme.color.text.primary
  },
  rightArrow: {
    width: isMobile ? '10%' : '5%',
    height: '0%',
    borderRadius: 50,
    marginLeft: '1rem',
    color: theme.color.text.secondary,
    backgroundColor: theme.background.tertiary
  },
  input: {
    display: 'flex',
    borderRadius: 50,
    marginLeft: isMobile ? 0 : '1rem',
    backgroundColor: theme.background.quaternary,
    width: '100%',
    ...customStyles.input
  }
});
